import { useState } from "react";
import "../Css/Pages/VenuesPage.css";
import FilterSidebar from "../Component/FilterSidebar";
import NoDataFound from "./NoDataFound";
import VendorCard from "../Component/VendorCard";
import { get } from "../services/ApiRouting";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Spin } from "antd"; // Assuming you're using antd for the Spin component

const VenuesPage = () => {
  const [vendors, setVendors] = useState([]);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const [limit, setLimit] = useState(10); // Assuming you want to limit the number of vendors displayed
  const [page, setPage] = useState(1); // Assuming you want to implement pagination

  const getQueryParams = () => {
    const params = new URLSearchParams(window.location.search);
    const search = params.get("search");
    const category = params.get("category");
    const subcategory = params.get("subcategory");
    const cast = params.get("cast"); // spelling assumed
    const event = params.get("event"); // spelling assumed
    const state = params.get("state"); // spelling assumed
    const city = params.get("city"); // spelling assumed
    const area = params.get("area"); // spelling assumed

    const paramUrl = new URLSearchParams();
    if (search) paramUrl.set("search", search);
    if (category) paramUrl.set("category", category);
    if (subcategory) paramUrl.set("subcategory", subcategory);
    if (cast) paramUrl.set("cast", cast);
    if (event) paramUrl.set("event", event);
    if (state) paramUrl.set("state", state);
    if (city) paramUrl.set("city", city);
    if (area) paramUrl.set("area", area);

    paramUrl.set("limit", limit);
    paramUrl.set("page", page);

    return paramUrl.toString();
  };

  const fetchVendors = async () => {
    try {
      setLoading(true);
      const response = await get(`vendors?${getQueryParams()}`);
      setVendors(response?.data);
    } catch (error) {
      console.error("Error fetching vendors:", error);
      setVendors([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const dbbounce = setTimeout(() => {
      fetchVendors();
    }, 300);

    return () => clearTimeout(dbbounce);
  }, [location.search]);

  return (
    <Spin spinning={loading}>
      <div className="venues-section-2-card-main-con">
        <div className="container">
          <div className="main-vendor-page-list-con">
            <div className="row">
              <div className="col-md-4">
                <div className="" style={{ position: "sticky", top: "11vh" }}>
                  <FilterSidebar />
                </div>
              </div>
              <div className="col-md-8 order-0 order-md-1">
                <div className="main-vendor-page-list-side-list-con">
                  <div className="row">
                    <div className="col-12 d-flex justify-content-start align-items-center py-10">
                      <br />
                      <h4>Filter Vendors</h4>
                      <br />
                    </div>
                    {vendors?.length > 0 ? (
                      vendors.map((elem) => {
                        const {
                          cover_image,
                          name,
                          based_area,
                          city,
                          pricing,
                          slug,
                        } = elem;
                        return (
                          <div
                            className="col-lg-4 col-md-6 col-sm-6 col-12 mb-4"
                            key={slug}
                          >
                            <VendorCard
                              loading={loading}
                              slug={slug}
                              cover_image={cover_image}
                              name={name}
                              based_area={based_area}
                              city={city}
                              pricing={pricing}
                            />
                          </div>
                        );
                      })
                    ) : (
                      <NoDataFound />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Spin>
  );
};

export default VenuesPage;
